<template>
  <div class="grid grid-cols-1 gap-4 w-full shrink-0">
    <div class="grid grid-cols-2 gap-4">
      <UFormField label="Nacionalidade" name="nationality" size="lg" :error="r$.nationality?.$error ? r$.nationality.$errors?.[0] : undefined">
        <USelect v-model="state.nationality" :items="['Brasileiro', 'Estrangeiro']" class="w-full" size="lg"
          :color="r$.nationality?.$dirty ? (r$.nationality.$correct ? 'success' : 'error') : 'neutral'" data-cy="register-nationality-select"
          @blur="r$.nationality?.$touch()"
          @update:model-value="handleNationalityChange" />
      </UFormField>

      <UFormField v-if="state.nationality === 'Brasileiro'" label="CPF" name="cpf" size="lg" :error="r$.cpf?.$error ? r$.cpf.$errors?.[0] : undefined">
        <UInput v-model="state.cpf" v-maska="'###.###.###-##'" placeholder="000.000.000-00" class="w-full" size="lg"
          :color="r$.cpf?.$dirty ? (r$.cpf.$correct ? 'success' : 'error') : 'neutral'" data-cy="register-cpf-input"
          @blur="r$.cpf?.$touch()">
          <template #trailing>
            <UIcon v-if="r$.cpf?.$correct" name="ph:check-circle" class="size-5 text-success shrink-0 me-2" aria-hidden="true" />
          </template>
        </UInput>
      </UFormField>

      <div v-else class="flex flex-col justify-center gap-1">
        <span class="text-sm font-medium text-gray-700 dark:text-gray-300">Documentação</span>
        <a href="urlFormDocumentoEstrangeiro" target="_blank" rel="noopener noreferrer"
           class="bg-gray-50 dark:bg-gray-800/50 p-2 rounded-lg inline-flex items-center gap-1.5 text-sm text-primary font-medium hover:underline underline-offset-2 transition-opacity hover:opacity-80">
          <UIcon name="ph:arrow-square-out" class="w-4 h-4" />
          Acessar formulário
        </a>
      </div>
    </div>

    <div class="grid grid-cols-2 gap-4">
      <UFormField v-if="state.nationality !== 'Estrangeiro'" label="Pessoas no domicílio" name="residents" size="lg" :error="r$.residents?.$error ? r$.residents.$errors?.[0] : undefined">
        <UInput v-model="state.residents" type="number" class="w-full" size="lg" data-cy="register-residents-input"
          :color="r$.residents?.$dirty ? (r$.residents.$correct ? 'success' : 'error') : 'neutral'"
          @blur="r$.residents?.$touch()">
          <template #trailing>
            <UIcon v-if="r$.residents?.$correct" name="ph:check-circle" class="size-5 text-success shrink-0 me-2" aria-hidden="true" />
          </template>
        </UInput>
      </UFormField>

      <UFormField label="Renda familiar" name="income" size="lg" :error="r$.income?.$error ? r$.income.$errors?.[0] : undefined">
        <USelect v-model="state.income" data-cy="register-income-select"
          :items="faixasRenda"
          class="w-full" size="lg"
          :color="r$.income?.$dirty ? (r$.income.$correct ? 'success' : 'error') : 'neutral'"
          @blur="r$.income?.$touch()">
          <template #trailing>
            <UIcon v-if="r$.income?.$correct" name="ph:check-circle" class="size-5 text-success shrink-0 me-2" aria-hidden="true" />
          </template>
        </USelect>
      </UFormField>
    </div>
  </div>
</template>

<script setup lang="ts">
import { vMaska } from 'maska/vue'
import {storeToRefs} from "pinia";

const urlFormDocumentoEstrangeiro = 'https://forms.gle/Z7X81ZSPpNjYreqD8'

const store = useRegisterStore()
const state = store.state

const { r$ } = useRegleSchema(state as any, step3Schema, { autoDirty: true })

defineExpose({
  validate: async () => await r$.$validate(),
  reset: () => r$.$reset()
})

const handleNationalityChange = (val: string) => {
  if (val === 'Estrangeiro') {
    store.state.cpf = ''
    store.state.residents = ''
  }
}
</script>